import { sendHapticFeedback as platformHaptic } from './platform';

export const sendHapticFeedback = () => {
    platformHaptic();
};
